import React from 'react';
import { connect } from 'react-redux';
import paging, { onCategoryScroll, reFetchConfig } from '@/hooks/paging';
import RequestsCards from '../components/RequestsCards';
import RequestsPanelContainer, {
  mapDispatchToProps,
  mapStateToProps,
} from '../components/RequestsPanelContainer';
import RequestsFilters from './RequestsFilters';

const RequestsPanelNarrow = ({
  canCreate,
  canRead,
  category,
  currentPage,
  fetchData,
  newRequestCode,
  onCheckBoxClick,
  pageCount,
  pageSize,
  readErrors,
  readStatus,
  requests,
  review,
  total,
}) => {
  paging.useFetchByCategory(fetchData, category, readStatus, reFetchConfig(requests, { pageSize, total }));
  return (
    <RequestsPanelContainer readErrors={readErrors} canRead={canRead} className="aridhia-requests-panel-narrow">
      <div className="sticky-panel-header">
        <RequestsFilters category={category} className="aridhia-list-filter" fluid />
      </div>
      <RequestsCards
        canCreate={canCreate && !review}
        category={category}
        handleScroll={() => onCategoryScroll(fetchData, category, currentPage, pageCount, pageSize)}
        items={requests}
        itemsPerRow={1}
        newRequestCode={newRequestCode}
        onCheckBoxClick={onCheckBoxClick}
        readErrors={readErrors}
        readStatus={readStatus}
        review={review}
      />
    </RequestsPanelContainer>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(RequestsPanelNarrow);
